const SELECTORS = {
  root: '[data-home-dashboard]',
  captionTrigger: '[data-home-card-caption]'
};
const EVENT_NAMES = ['DOMContentLoaded', 'turbolinks:load', 'turbo:load'];

const query = (selector, root = document) => root.querySelector(selector);
const queryAll = (selector, root = document) => Array.from(root.querySelectorAll(selector));
const getJQuery = () => window.jQuery || window.$;

const initializeCaptionPopup = (element) => {
  const $ = getJQuery();
  if (!$ || typeof $.fn?.popup !== 'function') return;
  if (element.dataset.homeCardCaptionInitialized === 'true') return;

  $(element).popup();
  element.dataset.homeCardCaptionInitialized = 'true';
};

class HomeCaptionsController {
  constructor(element) {
    this.element = element;
  }

  connect() {
    this.captionTriggers().forEach((trigger) => initializeCaptionPopup(trigger));
  }

  captionTriggers() {
    return queryAll(SELECTORS.captionTrigger, this.element);
  }
}

class HomeDashboardController {
  constructor(element) {
    this.element = element;
    this.captionsController = new HomeCaptionsController(element);
  }

  connect() {
    this.captionsController.connect();
  }
}

const initializeHomeDashboard = () => {
  const root = query(SELECTORS.root);
  if (!root) return;

  new HomeDashboardController(root).connect();
};

EVENT_NAMES.forEach((eventName) => {
  document.addEventListener(eventName, initializeHomeDashboard);
});

